exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-photo-list {\n  display: block;\n  max-height: 100vh;\n}\n.copied-photo {\n  position: absolute;\n  bottom: 0;\n  right: 10px;\n  color: #fff;\n  font-size: 3em;\n}\n\n", ""]);

// exports
